import { create } from 'zustand';

import { User } from '@/features/users/types/types';

type TUserState = {
  user: User | null;
  users: User[];
  setUser: (user: User) => void;
  setUsers: (users: User[]) => void;
};
export const useUserStore = create<TUserState>(set => ({
  user: null,
  users: [],
  setUser: (user: User) => set({ user }),
  setUsers: (users: User[]) => set({ users }),
}));
